module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00072-fs8.6656801.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00072-fs8.png
// module id = 225
// module chunks = 0